

const formationsData = {
  comptabilite: {
    title: "Formation Comptabilité à Rabat - Certifiée",
    image: "/formations_imgs/comptabilite.webp",
    definition:
      "Notre formation en comptabilité vous prépare à maîtriser la gestion financière des entreprises avec une approche pratique et moderne.",

    whyLearn: [
      "Formation 100% pratique",
      "Certificat reconnu",
      "Stage professionnel inclus",
      "Encadrement par experts du domaine"
    ],

    program: [
      "Comptabilité générale et analytique",
      "Analyse des états financiers",
      "Fiscalité et obligations légales",
      "Logiciels comptables professionnels"
    ],

    careers: [
      "Comptable certifié",
      "Assistant comptable",
      "Responsable financier",
      "Contrôleur de gestion"
    ]
  },

  informatique: {
    title: "Formation Informatique à Rabat - Certifiée",
    image: "/formations_imgs/informatique.webp",
    definition:
      "L’informatique consiste à développer, programmer et gérer des systèmes numériques.",
    whyLearn: [
      "Secteur en forte demande",
      "Opportunités internationales",
      "Possibilité freelance"
    ],
    program: [
      "HTML / CSS",
      "JavaScript",
      "Bases de données",
      "React"
    ],
    careers: [
      "Développeur Web",
      "Technicien informatique",
      "Administrateur système"
    ]
  },
  bureautique: {
    title: "Formation Bureautique à Rabat - Certifiée",
    image: "/formations_imgs/bureautique.webp",
    definition:
      "Maîtrisez les outils bureautiques indispensables pour travailler efficacement dans toute entreprise moderne.",

    whyLearn: [
      "Compétence demandée dans tous les secteurs",
      "Formation 100% pratique",
      "Augmente votre employabilité",
      "Base essentielle pour tout poste administratif"
    ],

    program: [
      "Microsoft Word avancé",
      "Excel professionnel",
      "PowerPoint",
      "Internet & Email professionnel",
      "Gestion documentaire"
    ],

    careers: [
      "Assistant administratif",
      "Agent de bureau",
      "Secrétaire",
      "Opérateur de saisie"
    ]
  },
  commerce: {
    title: "Formation Commerce à Rabat - Certifiée",
    image: "/formations_imgs/commerce.webp",
    definition:
      "Développez des compétences stratégiques en vente, négociation et gestion commerciale pour réussir dans le monde des affaires moderne.",

    whyLearn: [
      "Secteur dynamique avec forte demande",
      "Formation pratique orientée terrain",
      "Développement des compétences en négociation",
      "Possibilité d’évolution rapide"
    ],

    program: [
      "Techniques de vente avancées",
      "Négociation commerciale",
      "Gestion de la relation client (CRM)",
      "Stratégie commerciale",
      "Marketing appliqué au commerce"
    ],

    careers: [
      "Commercial",
      "Responsable des ventes",
      "Conseiller clientèle",
      "Représentant commercial",
      "Chef de rayon"
    ]
  },
  gestion: {
    title: "Formation Gestion à Rabat - Certifiée",
    image: "/formations_imgs/gestion.webp",
    definition:
      "Apprenez à gérer efficacement une entreprise : finance, management et organisation.",

    whyLearn: [
      "Compétence essentielle pour entrepreneurs",
      "Vision stratégique",
      "Formation pratique"
    ],

    program: [
      "Gestion financière",
      "Management",
      "Planification stratégique",
      "Organisation administrative"
    ],

    careers: [
      "Gestionnaire",
      "Chef d’entreprise",
      "Responsable administratif"
    ]
  },
  hotesse: {
    title: "Formation Hôtesse à Rabat - Certifiée",
    image: "/formations_imgs/hotesse.webp",
    definition:
      "Apprenez les techniques d’accueil, de communication et de présentation pour représenter une entreprise avec professionnalisme.",

    whyLearn: [
      "Métier valorisant et dynamique",
      "Formation pratique en communication",
      "Développement de la confiance en soi",
      "Forte demande dans hôtels, entreprises et événements"
    ],

    program: [
      "Techniques d’accueil professionnel",
      "Communication verbale et non verbale",
      "Gestion des visiteurs",
      "Présentation professionnelle",
      "Service client"
    ],

    careers: [
      "Hôtesse d’accueil",
      "Agent d’accueil",
      "Réceptionniste",
      "Chargée de relation client"
    ]
  },
  infographie: {
    title: "Formation Infographie à Rabat - Certifiée",
    image: "/formations_imgs/infographie.webp",
    definition:
      "Développez votre créativité et maîtrisez les outils professionnels de design graphique.",

    whyLearn: [
      "Secteur créatif en forte demande",
      "Travail en freelance possible",
      "Compétences artistiques valorisées"
    ],

    program: [
      "Photoshop",
      "Illustrator",
      "Création de logos",
      "Design publicitaire"
    ],

    careers: [
      "Graphiste",
      "Designer",
      "Créateur de contenu visuel"
    ]
  },
  marketing: {
    title: "Formation Marketing à Rabat - Certifiée",
    image: "/formations_imgs/marketing.webp",
    tagline: "Devenez expert en stratégie digitale et publicité en ligne.",
    definition:
      "Maîtrisez les stratégies digitales modernes : réseaux sociaux, publicité en ligne, branding et communication.",

    whyLearn: [
      "Métier très demandé",
      "Possibilité freelance",
      "Compétences digitales modernes",
      "Création de marque personnelle"
    ],

    program: [
      "Marketing Digital",
      "Facebook & Instagram Ads",
      "Création de contenu",
      "Stratégie de marque"
    ],

    careers: [
      "Community Manager",
      "Responsable Marketing",
      "Traffic Manager",
      "Freelance Digital"
    ]
  },
  secretariat: {
    title: "Formation Secrétariat à Rabat - Certifiée",
    image: "/formations_imgs/secretariat.webp",
    definition:
      "Formez-vous aux techniques administratives modernes pour devenir un pilier organisationnel au sein d’une entreprise.",

    whyLearn: [
      "Métier stable et recherché",
      "Formation complète et pratique",
      "Polyvalence professionnelle",
      "Opportunités dans tous les secteurs"
    ],

    program: [
      "Techniques de secrétariat",
      "Gestion administrative",
      "Rédaction professionnelle",
      "Organisation des dossiers",
      "Accueil et communication"
    ],

    careers: [
      "Secrétaire administratif",
      "Assistant de direction",
      "Agent administratif",
      "Assistant polyvalent"
    ]
  }
};

export default formationsData;